import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ShelfPrintList from '../../components/shelves/ShelfPrintList';
import { getRequestedUser } from '../../selectors/UserSelector';
import DocumentHeadContainer from '../DocumentHeadContainer';
import { getRequestedShelf, getShelfOwner } from '../../selectors/ShelfSelector';
import ShelfActions from '../../actions/ShelfActions';
import { currentUserSelector } from '../../selectors/AuthSelector';
import { getCurrentUserRatings } from '../../selectors/ugc/RatingsSelector';

export class PrintShelfContainer extends BcReactComponent {
  static fetchInitialData(params, query, store) {
    const user = params.userId ? getRequestedUser(store.getState()) : currentUserSelector(store.getState());
    const userId = user && user.get('id');
    if (userId && params.shelfName) {
      return [store.dispatch(ShelfActions.searchUserShelf(params.shelfName, userId, query))];
    }

    return [];
  }

  componentWillReceiveProps(nextProps) {
    const { location, params, owner } = this.props;
    const { location: nextLocation, params: nextParams } = nextProps;

    if ((params !== nextParams) || (location !== nextLocation)) {
      this.props.shelfActions.searchUserShelf(nextParams.shelfName, owner.get('id'), nextLocation.query);
    }
  }

  getFormatResults() {
    const { results, ratings, bibs } = this.props;
    return results.get('items').map(item =>
      item.set('format', bibs.getIn([item.get('metadataId'), 'briefInfo', 'format']))
      .set('callNumber', bibs.getIn([item.get('metadataId'), 'briefInfo', 'callNumber']))
      .set('currentUserRating', ratings.getIn([item.get('metadataId'), 'rating']))
    );
  }

  render() {
    const { pagination, intl, isFetching, username, shelfName, loggedIn } = this.props;
    const pageTitleId = `section_title_users_${shelfName}_shelf`;
    const pageTitle = intl.formatMessage({ id: pageTitleId }, { username });

    return (
      <div className="cp-shelf-print-list">
        <DocumentHeadContainer pageTitle={intl.formatMessage({ id: pageTitle })} />
        <ShelfPrintList
          isFetching={isFetching}
          results={this.getFormatResults()}
          pagination={pagination}
          username={username}
          shelfName={shelfName}
          loggedIn={loggedIn} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const owner = getShelfOwner(state);
  const shelfSearch = state.getIn(['shelves', 'shelfSearch']);

  return {
    pagination: shelfSearch.getIn(['shelf', 'pagination']),
    shelfName: shelfSearch.getIn(['shelf', 'name']),
    bibs: state.getIn(['entities', 'bibs'], Immutable.Map()),
    results: getRequestedShelf(state),
    username: owner.get('name'),
    ratings: owner.get('loggedIn') ? getCurrentUserRatings(state) : Immutable.Map(),
    loggedIn: !!owner.get('loggedIn'),
    isFetching: false
  };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch)
});

PrintShelfContainer.propTypes = {
  pagination: ImmutablePropTypes.map,
  results: ImmutablePropTypes.Map,
  bibs: ImmutablePropTypes.list,
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ratings: ImmutablePropTypes.map,
  intl: intlShape,
  isFetching: PropTypes.bool,
  shelfName: PropTypes.string,
  username: PropTypes.string,
  loggedIn: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrintShelfContainer));



// WEBPACK FOOTER //
// ./app/containers/print/PrintShelfContainer.jsx